"use strict";

exports.__esModule = true;
exports.MaxBinLimitWrapper = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _timeAggregationBinMapping = require("../../VIMANAMetrics/timeAggregationBinMapping");
var _TimePeriodController = require("../../Time/TimePeriodController");
var _timeDefinitions = require("../../timeDefinitions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var Container = _styledComponents["default"].div.withConfig({
  displayName: "MaxBinLimitWrapper__Container",
  componentId: "sc-16y93h2-0"
})(["display:flex;width:100%;height:100%;"]);
var MaxBinLimitWrapper = exports.MaxBinLimitWrapper = function MaxBinLimitWrapper(_ref) {
  var timeAggregationName = _ref.timeAggregationName,
    children = _ref.children;
  var _useSelectionContext = (0, _TimePeriodController.useSelectionContext)(),
    interval = _useSelectionContext.interval;
  var days = (interval.endMillis - interval.startMillis) / _timeDefinitions.DAY_IN_MILLIS;
  if (timeAggregationName === _timeAggregationBinMapping.HOUR_PER_DAY) {
    if (days > 20) {
      return /*#__PURE__*/_react["default"].createElement(Container, null, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          margin: "auto"
        }
      }, "Please select a smaller range of time"));
    }
  }
  return children;
};